// extracted by mini-css-extract-plugin
export default {"container":"CRPage_container__uYBIR","deleteBtn":"CRPage_deleteBtn__3oHfD","table-wrapper":"CRPage_table-wrapper__iqSM0"};